export default __webpack_public_path__ + "static/media/facebook-black.298532aa.svg";